// extracted by mini-css-extract-plugin
module.exports = {"red":"_27AQLODuOWqIo8YRvhsmV3"};